const parseIntValue = (value) => value == null || value === '' ? '' : parseInt(value, 10)

export default parseIntValue



// WEBPACK FOOTER //
// ./src/utils/parsers/parseIntValue.js